import React from 'react';
import '../../styles/animations.css';

const SimpleAnimatedBackground = () => {
  // Generate random number between min and max
  const random = (min, max) => Math.random() * (max - min) + min;
  
  // Create an array of animated elements
  const createElements = (count, className) => {
    return Array.from({ length: count }).map((_, index) => {
      const styles = {
        left: `${random(0, 100)}%`,
        top: `${random(0, 100)}%`,
        animationDuration: `${random(15, 45)}s`,
        animationDelay: `${random(0, 5)}s`,
        width: `${random(20, 100)}px`,
        height: `${random(20, 100)}px`,
        opacity: random(0.2, 0.5)
      };
      
      return (
        <div
          key={`${className}-${index}`}
          className={`simple-animated-element ${className}`}
          style={styles}
        />
      );
    });
  };
  
  // Create code snippets
  const createCodeSnippets = (count) => {
    const snippets = [
      'function testAutomation() { ... }',
      'robot.click(selector);',
      'await page.waitForSelector();',
      'test.assert(condition);',
      'const results = await robot.run();',
      'class AutomationTest { ... }',
      'import { test } from "framework";',
      'export default TestSuite;'
    ];
    
    return Array.from({ length: count }).map((_, index) => {
      const styles = {
        left: `${random(0, 100)}%`,
        top: `${random(0, 100)}%`,
        animationDuration: `${random(20, 40)}s`,
        animationDelay: `${random(0, 5)}s`,
        opacity: random(0.3, 0.6),
        fontSize: `${random(12, 18)}px`
      };
      
      return (
        <div 
          key={`code-${index}`} 
          className="simple-animated-code" 
          style={styles}
        >
          {snippets[Math.floor(random(0, snippets.length))]}
        </div>
      );
    });
  };
  
  // Create gear elements
  const createGears = (count) => {
    return Array.from({ length: count }).map((_, index) => {
      const size = random(30, 80);
      const styles = {
        left: `${random(0, 100)}%`,
        top: `${random(0, 100)}%`,
        width: `${size}px`,
        height: `${size}px`,
        animationDuration: `${random(20, 60)}s`,
        animationDelay: `${random(0, 5)}s`,
        opacity: random(0.3, 0.5)
      };
      
      return (
        <div 
          key={`gear-${index}`} 
          className="simple-animated-gear" 
          style={styles}
        />
      );
    });
  };
  
  return (
    <div className="simple-animated-background">
      {createElements(10, 'circle')}
      {createElements(8, 'square')}
      {createElements(6, 'triangle')}
      {createCodeSnippets(12)}
      {createGears(8)}
    </div>
  );
};

export default SimpleAnimatedBackground;